import { supabase } from "@/services";

export async function getProjectDetails(projectId: string) {
    const { data: project, error } = await supabase
        .from("projects")
        .select("*")
        .eq("project_id", projectId)
        .single();

    if (error) console.error("Error fetching project:", error);
    return project;
}
